import React, { useEffect, useState } from "react";
import styles from "./YoutubeUploadPopup.module.css";
import youtube from "../../assests/youtube.svg";

const YoutubeUploadPopup = ({
  files,
  setSource,
  setUploadPopup,
  backgroundColor,
  setYoutubeLinks,
  youtubeLinks,
}) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  const handleInputChange = (value, index) => {
    setYoutubeLinks((prevState) => {
      let newLinkArray = prevState;
      let newObj = newLinkArray[index] || {};
      newObj.fileUrl = value;
      newObj.fileType = "video/youtube";
      newLinkArray[index] = newObj;
      return newLinkArray;
    });
  };
  const handleNext = () => {
    setUploadPopup(false);
    const newFileUrls = youtubeLinks?.map((file) => file?.fileUrl);
    setSource((prevFileUrls) => [...prevFileUrls, ...newFileUrls]);
  };
  return (
    <div className={styles.mainDiv}>
      <div className={styles.container}>
        <img src={youtube} alt="" className="w-[56px] h-[56px] mb-[24px]  " />
        <p className="text-regular-medium px-[20px] mb-[10px]">
          Paste Youtube Link
        </p>
        <p className="text-small text-[#CDCDCD] px-[20px] mb-[16px]">
          You can add maximum of {files} link(s)
        </p>
        <div className="flex flex-col gap-[10px] text-small w-full">
          {Array.from({ length: files }, (_, index) => {
            return (
              <input
                type="text"
                placeholder={`${index + 1}) Paste link here`}
                value={youtubeLinks[index] && youtubeLinks[index].fileUrl}
                onChange={(e) => handleInputChange(e.target.value, index)}
                className={styles.input}
              />
            );
          })}
        </div>
        <div className="seperator my-[20px]" />

        <div className="flex flex-col gap-[16px] w-[100%] cursor-pointer">
          <button
            className={`text-regular-medium ${styles.button}`}
            onClick={handleNext}
            style={{
              backgroundColor: backgroundColor,
            }}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default YoutubeUploadPopup;
